var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visible && _setup.switchThemeConfig.visible)?_c(_setup.IconButton,{attrs:{"title":_setup.t('Switch Theme'),"layout":_setup.IconButtonLayout.HORIZONTAL,"icon":_setup.SwitchThemeIcon},on:{"click-icon":_setup.handleSwitchTheme}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }